import {Mutator} from 'final-form';

const setFieldData: Mutator<any> = ([name, data], state) => {
  const field = state.fields[name];
  if (field) {
    if (data === null) {
      field.data = {}
    } else {
      field.data = { ...field.data, ...data }
    }
  }
}

export default setFieldData;
